<template>
    <div class="merged-page">
        <AppBreadCrumb :paths="[{ title: $t('message.bannedVisitors') }]" :select="true">
            <a-input-search
                v-model="searchText"
                :placeholder="$t('message.startFilter')"
                class="search-input"
                @search="onSearch"
            />
        </AppBreadCrumb>
        <!--        {{bannedVisitors.data}}-->
        <div style="background-color: #ffffff" class="d-flex w-100">
            <div class="side-menubar-wrapper" style="width: 15%">
                <UsersMenu />
            </div>
            <div id="banned-visitors">
                <b-container fluid>
                    <div class="audit-logs">
                        <div class="page-header"></div>
                        <div class="table-wrapper">
                            <section>
                                <ve-table
                                    :columns="getColumns()"
                                    :table-data="getFilteredRows()"
                                    :row-style-option="rowStyleOption"
                                    :border-x="true"
                                    :border-y="true"
                                    row-key-field-name="_id"
                                    class="ban-list-table"
                                    style="width: 1130px"
                                    :scroll-width="1130"
                                    :virtualScrollOptions="{ itemSize: 50, height: 500 }"
                                    :event-custom-option="eventCustomOption"
                                />
                            </section>
                        </div>
                    </div>
                    <div class="mt-3 d-flex justify-content-end">
                        <Pagination :page-change="pageChange" :page-sizes="pageSizes" :total="bannedVisitors.total" />
                    </div>
                </b-container>
            </div>
        </div>
        <ChatBar v-if="!isAdmin" :visible="false" />
        <div class="fab d-flex justify-content-center align-items-center" @click="isBanModalShow = true">
            <md-icon class="">add</md-icon>
        </div>
        <VisitorManuelBanModal
            :ban-modal-visible="isBanModalShow"
            @close="isBanModalShow = false"
            @update="refreshTable"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import * as _ from "lodash";
import { log2 } from "../../utils/log2";
import ChatBar from "../../components/ChatBar";
import { sendSocketMessage } from "../../utils/socketStream";
import { tableSorter } from "../../utils/utils";
import Pagination from "../../components/Pagination";
import UsersMenu from "./UsersMenu";
import SupsisButton from "./Settings/components/SupsisButton.vue";
import Vue from "vue";
import { ACTIVITY_API } from "../../api/activity";
import moment from "moment";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-json";
import "prismjs/themes/prism-tomorrow.css";
import webIcon from "../../views/Pages/Visitors/components/svg/WebIcon.vue";
import whatsappIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import { SUPPRESSION_API } from "../../api/suppression";
import gmailIcon from "./Mail/icons/MailIcon.vue";
import Modal2 from "../../components/common/Modal2.vue";
import VisitorManuelBanModal from "../../components/VisitorManuelBanModal.vue";

library.add(faUnlockAlt);
const log = log2("BannedVisitors");
export default {
    name: "BannedVisitors",
    components: {
        Modal2,
        SupsisButton,
        AppBreadCrumb,
        ChatBar,
        Pagination,
        UsersMenu,
        PrismEditor,
        webIcon,
        whatsappIcon,
        gmailIcon,
        VisitorManuelBanModal,
    },
    data() {
        return {
            isBanModalShow: false,
            isBusy: true,
            pageSizes: ["10", "25", "50", "100"],
            searchText: undefined,
            rowStyleOption: {
                stripe: true,
            },
            page: 1,
            perPage: 100,
            renderCount: 0,
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            bannedVisitors: {
                data: [],
                total: 0,
            },
            eventCustomOption: {
                bodyCellEvents: ({ row, column, rowIndx }) => {
                    return {
                        dblclick: (event) => {
                            let text = event.toElement.innerText;
                            let textArea = document.createElement("textarea");
                            textArea.value = text;
                            document.body.appendChild(textArea);
                            textArea.select();
                            document.execCommand("copy");
                            document.body.removeChild(textArea);
                            this.$message.success({
                                content: this.$t("message.copiedClipboard"),
                                duration: 2,
                                key: "saved",
                            });
                        },
                    };
                },
            },
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            isAdmin: (state) => state.auth.adminUser != null,
            user: (state) => state.auth.user,
            isRoot: (state) => state.auth.user.role.isRoot,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
    },
    methods: {
        ...mapActions({
            unbanVisitor: "visitor/unbanVisitor",
            addNewWindow: "app/addNewWindow",
        }),
        handleUpdate() {
            alert("updated");
        },
        getColumns() {
            console.log("getColumns", this.users);
            return [
                {
                    field: "platform",
                    key: "platform",
                    title: this.$t("message.platform"),
                    align: "Center",
                    fixed: "left",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.type === "web-visitor-ip") {
                            return <webIcon color="black" class="banlist-web-icon" />;
                        } else if (row.type === "whatsapp") {
                            return <whatsappIcon color="#25D366" class="banlist-web-icon" />;
                        } else if (row.type === "email") {
                            return <gmailIcon />;
                        } else if (row.type === "web-visitor") {
                            return (
                                <img
                                    src="https://static.supsis.live/common/email/supsisyazisislogo.png"
                                    class="banlist-web-icon"
                                />
                            );
                        }
                    },
                },
                {
                    key: "email",
                    title: this.$t("message.email"),
                    align: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content: row.visitor ? row.visitor.email : row.email,
                                        },
                                    },
                                ],
                            },
                            row.visitor ? row.visitor.email : row.email
                        );
                    },
                },
                {
                    key: "fullname",
                    title: this.$t("message.fullname"),
                    align: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content: row.visitor?.fullname,
                                        },
                                    },
                                ],
                            },
                            row.visitor?.fullname
                        );
                    },
                },
                {
                    key: "number",
                    title: this.$t("whatsappChannel.phoneNummer"),
                    align: "left",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content: row.whatsapp ? row.whatsapp : row.whatsappNumber,
                                        },
                                    },
                                ],
                            },
                            row.whatsapp ? row.whatsapp : row.whatsappNumber
                        );
                    },
                },
                {
                    key: "ipAddress",
                    title: this.$t("userInfoWidget.IPAddress"),
                    align: "left",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content: row.visitor ? row.visitor.ipAddress : row.ipAddress,
                                        },
                                    },
                                ],
                            },
                            row.visitor ? row.visitor.ipAddress : row.ipAddress
                        );
                    },
                },
                {
                    key: "country",
                    title: this.$t("message.country"),
                    align: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content: row.visitor?.country,
                                        },
                                    },
                                ],
                            },
                            row.visitor?.country
                        );
                    },
                },
                {
                    key: "city",
                    title: this.$t("message.city"),
                    align: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content: row.visitor?.city,
                                        },
                                    },
                                ],
                            },
                            row.visitor?.city
                        );
                    },
                },
                {
                    key: "browser",
                    title: this.$t("message.browser"),
                    align: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content: row.visitor?.browser,
                                        },
                                    },
                                ],
                            },
                            row.visitor?.browser
                        );
                    },
                },
                {
                    key: "os",
                    title: this.$t("message.os"),
                    align: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content: row.visitor?.os,
                                        },
                                    },
                                ],
                            },
                            row.visitor?.os
                        );
                    },
                },
                {
                    field: "connectionTime",
                    key: "connectionTime",
                    title: this.$t("message.connectionDate"),
                    align: "left",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.createdAt).format("D MMMM YYYY, HH:mm")}</span>;
                    },
                },
                {
                    key: "createdBy",
                    title: this.$t("message.blockBy"),
                    align: "left",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(
                            "span",
                            {
                                directives: [
                                    {
                                        name: "tippy",
                                        value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                            content:
                                                row.createdBy?.type === "user"
                                                    ? row.createdBy.user.email
                                                    : row.createdBy?.type || "N/A",
                                        },
                                    },
                                ],
                            },
                            row.createdBy?.type === "user" ? row.createdBy.user.name : row.createdBy?.type || "N/A"
                        );
                    },
                },
                {
                    field: "sending",
                    key: "Sending",
                    title: this.$t("message.sendingAllow"),
                    align: "center",
                    width: 110,
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }) => {
                        return (
                            <a-switch
                                on-change={() => this.suppressionProcess(row, "outbound")}
                                checked-children="✖"
                                un-checked-children="✔"
                                checked={row.outbound}
                                value={row.outbound}
                            />
                        );
                    },
                },
                {
                    field: "receiving",
                    key: "Receiving",
                    title: this.$t("message.receiving"),
                    align: "center",
                    width: 110,
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <a-switch
                                on-change={() => this.suppressionProcess(row, "inbound")}
                                checked-children="✖"
                                un-checked-children="✔"
                                checked={row.inbound}
                                value={row.inbound}
                            />
                        );
                    },
                },
                {
                    field: "transactions",
                    key: "transactions",
                    title: this.$t("message.transactions"),
                    scopedSlots: { customRender: "actionsSlot" },
                    width: 100,
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.type === "web-visitor") {
                            return (
                                <div class="actions">
                                    <SupsisButton onClick={() => this.viewContactProfile(row.visitor)} small>
                                        <i class="material-icons text-primary">contact_page</i>
                                    </SupsisButton>
                                </div>
                            );
                        }
                    },
                },
            ];
        },
        refreshTable() {
            setTimeout(() => {
                this.get();
            }, 1000);
        },
        suppressionProcess(row, direction) {
            row[direction] = !row[direction];
            let value;
            if (row.type === "web-visitor") {
                value = row.visitor?._id;
            } else if (row.type === "web-visitor-ip") {
                value = row.ipAddress;
            } else if (row.type === "whatsapp") {
                value = row.whatsapp;
            } else if (row.type === "email") {
                value = row.email;
            }
            if (!row?.outbound && !row?.inbound) {
                SUPPRESSION_API.remove(row.type, value).then(() => {
                    this.$message.success({
                        content: this.$t("chatbotv2.suppressionRemoved"),
                        duration: 2,
                        key: "saved",
                    });
                    this.refreshTable();
                });
            } else {
                SUPPRESSION_API.update(row.type, value, !!row?.inbound, !!row?.outbound, this.user._id);
            }
        },
        tableChange(pagination, filters, sorter) {
            log("tableChange", { pagination, filters, sorter });
            this.perPage = pagination.pageSize;
            log("tableChange", { pagination, filters, sorter });
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            log("show me current Sort", {
                currentSort: this.currentSort,
                newSort,
            });
            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
        getFilteredRows() {
            return this.searchText
                ? this.bannedVisitors.data.filter(
                      (x) =>
                          (x.email &&
                              x.email
                                  .toLocaleLowerCase("tr-TR")
                                  .includes(this.searchText.toLocaleLowerCase("tr-TR"))) ||
                          (x.visitor?.email &&
                              x.visitor?.email
                                  .toLocaleLowerCase("tr-TR")
                                  .includes(this.searchText.toLocaleLowerCase("tr-TR"))) ||
                          (x.visitor?.fullname &&
                              x.visitor?.fullname
                                  .toLocaleLowerCase("tr-TR")
                                  .includes(this.searchText.toLocaleLowerCase("tr-TR"))) ||
                          (x.browser &&
                              x.browser
                                  .toLocaleLowerCase("tr-TR")
                                  .includes(this.searchText.toLocaleLowerCase("tr-TR"))) ||
                          (x.city &&
                              x.city.toLocaleLowerCase("tr-TR").includes(this.searchText.toLocaleLowerCase("tr-TR"))) ||
                          (x.country &&
                              x.country
                                  .toLocaleLowerCase("tr-TR")
                                  .includes(this.searchText.toLocaleLowerCase("tr-TR"))) ||
                          (x.os &&
                              x.os.toLocaleLowerCase("tr-TR").includes(this.searchText.toLocaleLowerCase("tr-TR"))) ||
                          (x.ipAddress &&
                              x.ipAddress
                                  .toLocaleLowerCase("tr-TR")
                                  .includes(this.searchText.toLocaleLowerCase("tr-TR"))) ||
                          (x.whatsapp &&
                              x.whatsapp
                                  .toLocaleLowerCase("tr-TR")
                                  .includes(this.searchText.toLocaleLowerCase("tr-TR")))
                  )
                : this.bannedVisitors.data;
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
        },
        pageChange(page, pageSize) {
            log("pageChange", { page, pageSize });
            this.page = page;
            this.perPage = pageSize;
        },
        onShowSizeChange(current, pageSize) {
            log("onShowSizeChange", current, pageSize);
            this.page = current;
            this.perPage = pageSize;
        },
        async get() {
            await SUPPRESSION_API.list(this.searchText, {
                page: this.page,
                perPage: this.perPage,
            }).then((response) => {
                this.bannedVisitors.data = response.data.contacts;
                this.bannedVisitors.total = response.data.total;
                this.isBusy = false;
            });
        },
        viewContactProfile(item) {
            this.addNewWindow({
                type: "show-visitor",
                title: `${item.fullname} Profile`,
                payload: {
                    visitorId: item._id,
                },
            });
        },
    },
    async mounted() {
        this.get();
        setTimeout(() => {
            console.log("Banned Visitor List", { visitors: this.bannedVisitors.data });
        }, 1000);
    },
    watch: {
        page(newValue) {
            if (newValue) {
                this.get();
            }
        },
        perPage(newValue) {
            if (newValue) {
                this.get();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.new-theme {
    #banned-visitors {
        min-height: 90vh;
        width: 85%;
        background: #eef0f8;

        .container-fluid {
            padding-right: 0 !important;
        }

        .actionButton {
            border: none;
            box-shadow: none;
        }
    }
}
</style>
<style lang="scss">
#banned-visitors {
    .ant-switch-checked {
        background: #cc0100 !important;
    }

    .ant-switch {
        background: green;
    }

    .ban-modal-icon {
        width: 20px;
        height: 20px;
    }

    .table-wrapper {
        height: 80vh !important;
        overflow-y: scroll;
    }

    .banlist-web-icon {
        width: 30px;
        height: 30px;
    }

    .actions {
        .supsis-button {
            background: transparent !important;
            border: none !important;
        }
    }
}
</style>
